import React, { useState } from "react";
import PatientInfo1 from "./PatientInfo1";
import Submit from "../pages/submit/Submit";
import MuiStepper from "../components/stepper/MuiSteper";
import TFOneSocketMeasure from "../pages/patientMeasurement/TFOneSocketMeasure";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import OneSocketPatientReview from "./OneSocketPatientReview";
import LinerSelection from "./LinerSelection";
import FootSelection from "./FootSelection";
import axios from "axios";
import Config from "../common/Config";
import AccountNumberPage from "./AccountNumberPage";

const TFOneSocket = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempCart, setTempCart] = useState(Array(0));
  const [init, setInit] = useState(true);

  const formTypeId = 8;

  const loadCart = () => {
    setTempCart([]);
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    axios.get(
      Config.baseApiUrl + "cart/" + formTypeId,
      config
    ).then(response => {
      setCart(response.data);
    }).catch(error =>{
      console.log(error)
    });
  }

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }
  
  const handleNext = () => {
    loadCart();
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };

  const handleBack = () => {
    loadCart();
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };
  const handleClearBack = () => {
    loadCart();
    setActiveOuterStep(0);
    setActiveInnerStep(0);    
  };

  const formData = [
    {
      id: 1,
      name: "Patient Information",
      innerSteps: [
        { id: 1, name: "Patient Info", isActive: true },
        { id: 2, name: "Amputation Level", isActive: true },
        { id: 3, name: "Amputation Side", isActive: true },
        { id: 4, name: "K Level", isActive: true },
      ],
      formContent: (
        <PatientInfo1
          disableBackButton={localStorage.getItem("internalAccount") === null}
          setActiveInnerStep={setActiveInnerStep}
          handleNext={handleNext}
          handleBack={handleBack}
          formTypeId={formTypeId}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 2,
      name: "Product Information",
      innerSteps: [
        { id: 1, name: "Measurements", isActive: true },
        { id: 2, name: "One® System", isActive: true },
        { id: 3, name: "Socket Finish", isActive: true },
        { id: 4, name: "Mounting Plate", isActive: true },
        { id: 5, name: "Prosthetic Height Adjustment", isActive: true },
        { id: 6, name: "Earliest Ship Date", isActive: true },
        { id: 7, name: "Notes", isActive: true },
      ],
      formContent: (
        <TFOneSocketMeasure
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 4,
      name: "Liners",
      innerSteps: [],
      formContent: (
        <LinerSelection
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 5,
      name: "Foot",
      innerSteps: [],
      formContent: (
        <FootSelection
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 6,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 7,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 8,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <OneSocketPatientReview
          formTypeId={8}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="TT One® Socket"
          handleClearBack = {handleClearBack}
        />
      ),
    },

    {
      id: 9,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];

  if(localStorage.getItem("internalAccount")) {
    formData.unshift({
      id: 0,
      name:"Account Number",
      formContent: (
        <AccountNumberPage 
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      )
    })
  }

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);

  if(init) {
    loadCart();
    setInit(false);
  }

  return (
    <div>
      <MuiStepper
        data={formData}
        innerStep={activeInnerStep}
        setInnerStep={setActiveInnerStep}
        setActiveOuterStep={setActiveOuterStep}
        activeOuterStep={activeOuterStep}
        formName="TF One® Socket"
        totalSteps={totalIds}
        cart={joinedCart()}
      />
    </div>
  );
};

export default TFOneSocket;
